import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DateAttributeFilter } from 'app/shared/ui/models/date-attribute-filter';

@Component({
  selector: 'jhi-datetime-filter',
  templateUrl: './datetime-filter.component.html',
  styleUrls: ['./datetime-filter.component.scss'],
})
export class DatetimeFilterComponent {
  @Input() filter!: DateAttributeFilter;
  @Output() filterChange = new EventEmitter<DateAttributeFilter>();
}
